module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d5f67ae3bf2225695aa7ed656082a31f.png";